import { REGIONS } from 'consts';

import { OfferDetails } from 'codegen';
import { TFieldProps } from 'types';

export const genericFields = (
  isNew: boolean,
  isParticipation: boolean,
): TFieldProps[] => [{
  type: TFieldProps.type.Text,
  name: ['genericValues', 'name'],
  label: 'Internal Name',
  rules: [{
    message: 'Internal Name is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.DatePicker,
  label: 'Effective From',
  name: ['genericValues', 'effectiveFrom'],
  showTime: true,
  rules: [{
    message: 'Effective From is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.DatePicker,
  name: ['genericValues', 'displayFrom'],
  label: 'Display From',
  showTime: true,
  rules: [{
    message: 'Display From is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.DatePicker,
  name: ['genericValues', 'effectiveTo'],
  label: 'Effective To',
  showTime: true,
  rules: [{
    message: 'Effective To is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.TreeSelect,
  name: ['genericValues', 'regions'],
  label: 'Regions',
  treeData: REGIONS,
  maxTagCount: 2,
  maxTagPlaceholder: (omittedValues) => `+ ${omittedValues.length} Regions ...`,
  rules: [{
    type: 'array',
    min: 1,
    required: true,
    message: 'Select minimum 1 region!',
  }],
}, {
  type: TFieldProps.type.Checkbox,
  name: ['genericValues', 'isParticipation'],
  label: 'Participation Offer',
  disabled: !isNew,
}, {
  type: TFieldProps.type.Number,
  name: ['genericValues', 'maxRedeemsPerCollector'],
  label: 'Usage Limit Per Collector',
  isToggle: isNew,
  max: 100,
}, {
  type: TFieldProps.type.Number,
  name: ['genericValues', 'receiptAcceptanceDaysThreshold'],
  label: 'Days Threshold',
  disabled: isParticipation,
  precision: 0,
}, {
  type: TFieldProps.type.Select,
  name: ['genericValues', 'rewardScope'],
  label: 'Offer Applied To',
  disabled: isParticipation,
  options: [{
    label: 'Every Line Item',
    value: OfferDetails.rewardScope.LINE_ITEM,
  }, {
    label: 'Whole Receipt',
    value: OfferDetails.rewardScope.RECEIPT,
  }],
}];

export const milesConfigFields: TFieldProps[] = [{
  type: TFieldProps.type.Number,
  name: ['milesConfigurationValues', 'miles'],
  label: 'Points',
  min: 1,
  precision: 0,
}, {
  type: TFieldProps.type.Text,
  name: ['milesConfigurationValues', 'offerCode'],
  label: 'Offer Code',
  rules: [{
    message: 'Offer code must contain between 1 and 8 symbols!',
    required: true,
  }, {
    max: 8,
    message: 'Offer Code must be maximum 8 symbols!',
  }],
}, {
  type: TFieldProps.type.Text,
  name: ['milesConfigurationValues', 'sponsorCode'],
  label: 'Sponsor Code',
  rules: [{
    message: 'Sponsor Code is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.Checkbox,
  name: ['milesConfigurationValues', 'isRiceCalculationEnabled'],
  label: 'Rice calculation enabled',
}];
